<template>
  <div>
    <!-- <div class="header red" :class="[hasHeaderBg ? 'hasHeaderBg' : '']"> -->
    <div class="header" :class="[hasHeaderBg ? 'hasHeaderBg' : '']">
      <div class="NavTop">
        <a href="https://www.coalgeocloud.com/">
          <div class="logo">
            <img src="@/assets/img/logo.png" />
          </div>
        </a>
        <!-- <div class="head-v3">
          <div class="navigation-up">
            <div class="navigation-inner" >
              <div class="navigation-v3" id="navigationItem"> -->
                <ul class="navigation">
                  <li _t_nav="home">
                    <h2><a href="/">首页</a></h2>
                  </li>
                  <li v-bind:_t_nav="model.MenuName" v-for="(model, index) in headList" v-bind:key="model.ID"
                    @click="enterClick(index)" :class="index == current ? 'nav-up-selected' : ''">
                    <h2>
                      <template v-if="
                          model.ExternalLink == '3' || model.OpenType == '2'
                        ">
                        <a v-bind:href="model.MenuUrl" target="_blank">{{
                          model.MenuName
                        }}</a>
                      </template>
                      <template v-else>
                        <router-link v-bind:to="model.MenuUrl">{{
                          model.MenuName
                        }}</router-link>
                      </template>
                    </h2>
                    <div class="navigation-down" @mouseleave="leave()">
                      <div v-bind:id="model.MenuName" class="nav-down-menu menu-3 menu-1"
                        v-show="seen && index == current" v-bind:_t_nav="model.MenuName">
                        <div class="navigation-down-inner">
                          <dl v-for="childrenmodel in model.children" v-bind:key="childrenmodel.ID">
                            <template v-if="childrenmodel.children.length > 0">
                              <dt>
                                <template v-if="
                                    childrenmodel.ExternalLink == '3' ||
                                    childrenmodel.OpenType == '2'
                                  ">
                                  <a v-bind:href="childrenmodel.MenuUrl"
                                    target="_blank">{{ childrenmodel.MenuName }}</a>
                                </template>
                                <template v-else>
                                  <router-link v-bind:to="childrenmodel.MenuUrl">{{ childrenmodel.MenuName }}
                                  </router-link>
                                </template>
                              </dt>
                              <dd v-for="threemodel in childrenmodel.children" v-bind:key="threemodel.ID">
                                <template v-if="
                                    threemodel.ExternalLink == '3' ||
                                    threemodel.OpenType == '2'
                                  ">
                                  <a v-bind:href="threemodel.MenuUrl" target="_blank">{{ threemodel.MenuName }}</a>
                                </template>
                                <template v-else>
                                  <router-link v-bind:to="threemodel.MenuUrl">{{
                                    threemodel.MenuName
                                  }}</router-link>
                                </template>
                              </dd>
                            </template>
                            <template v-else>
                              <dd>
                                <template v-if="
                                    childrenmodel.ExternalLink == '3' ||
                                    childrenmodel.OpenType == '2'
                                  ">
                                  <a v-bind:href="childrenmodel.MenuUrl"
                                    target="_blank">{{ childrenmodel.MenuName }}</a>
                                </template>
                                <template v-else>
                                  <router-link v-bind:to="childrenmodel.MenuUrl">{{ childrenmodel.MenuName }}
                                  </router-link>
                                </template>
                              </dd>
                            </template>
                          </dl>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              <!-- </div>
            </div>
          </div>
        </div> -->

        <div class="top-search">
          <input name="search" v-model="seachvalue" type="text" placeholder="输入关键字搜索" class="form-control searchtext"
            @keyup.enter="submiturl()" />
          <span class="input-group-btn">
            <button type="submit" @click="submiturl" class="search-button">
              <i class="icon iconfont iconsousuo"></i>
            </button>
          </span>
        </div>


        <div class="top-dl" v-if="!Islogin">
          <router-link to="/Login" style="color:#fff">登录</router-link>
          <router-link to="/Register" style="color:#fff">注册</router-link>
        </div>
        <div class="top-dl" v-else>
          <div class="top-dl-h">
            <el-dropdown>
              <span class="el-dropdown-link">
                <i class="el-icon-s-custom"></i> 欢迎您，{{ userName
                }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item icon="el-icon-s-custom" @click.native="onclick">个人中心</el-dropdown-item>
                <el-dropdown-item icon="el-icon-switch-button" @click.native="logout">退出</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="download-text-box" style="
            float: right;
            margin-right: 8px;
            font-size: 12px;
            color: #fff;
            margin-top: 32px;
            cursor: pointer;
          " @click="showym">
          <i class="fa fa-mobile" style="margin-right: 5px; font-size: 16px"></i>帮助中心 <span
            style="margin-left: 8px; vertical-align: top">|</span>
        </div>
        <div class="download-text-box" style="
            float: right;
            margin-right: 8px;
            font-size: 12px;
            color: #fff;
            margin-top: 32px;
            cursor: pointer;
          ">
          <i class="fa fa-mobile" style="margin-right: 5px; font-size: 16px"></i>APP下载 <span
            style="margin-left: 8px; vertical-align: top">|</span>
          <div style="display: inline-block">
            <div style="position: relative">
              <div class="qr-code-hover" style="">
                <div>
                  <img src="@/assets/img/app.png" alt="" style="width: 190px" />
                </div>
                <div style="color: #2b2b2b; font-size: 14px; padding-top: 8px">
                  欢迎下载"煤炭地质云"手机APP
                </div>
              </div>
            </div>
          </div>
        </div>
        

        <div class="clear"></div>
      </div>
    </div>
    <el-dialog title="帮助中心" :visible.sync="dialogTableVisible" width="40%" :close-on-click-modal="false">
      <a href="https://support.qq.com/products/413083" target="_blank" style="margin-left: 570px;
    margin-bottom: 20px;
    font-size: 15px;
    font-weight: 800;
    color: #409eff;">意见反馈</a>
      <el-table :data="tableUserManualData" style="width: 100%;">
        <el-table-column prop="Name" label="文件名称">
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.$index, scope.row)" type="text" size="small">下载</el-button>
            <el-button type="text" size="small" @click="zxshow(scope.$index, scope.row)">在线预览</el-button>
          </template>
        </el-table-column>
      </el-table>
       
    </el-dialog>
  </div>
</template>
<style scoped>
  .el-dropdown {
    color: #fff;
  }

</style>
<script>
  import "@/assets/css/mycss/bootstrap.min.css";
  import "@/assets/css/mycss/default.css";
  import "@/assets/font/iconfont.css";
  import "@/assets/js/jquery-2.1.1.min.js";
  import "@/assets/js/menu.js";
  import {
    GetData,
    getUserManualALLList
  } from "@/api/head.js";
  export default {
    components: {
      
    },
    data() {

      return {
        // navWidth: "",
        // navHeight: "",
        dialogTableVisible: false,
        headList: [],
        seen: false,
        current: -1,
        seachvalue: "",
        Islogin: (this.$store.getters.token !== 'undefined' && this.$store.getters.token != null && this.$store.getters
          .token !== '') ? true : false,
        tableUserManualData: [],
      };
    },
    computed: {
      hasHeaderBg() {
        /*纯色背景header,注意字母全部小写*/
        let arr = [
          "/404",
          "/403",
          "/5001",
          "/5002",
          "/5003",
          "/nanfang",
          "/personalinfo",
          "/enterpriseinfo",
          "/auditprocesslist",
          "/myfavorite",
          "/mycloudstorage",
          "/footprint",
          "/onlineservice",
          "/register",
          "/coalmanagement",
          "/projectworkreportdeail",
          "/geologicalquery",
          "/knowledge/preview",
          "/projectweeklyreportdeail",
          "/projectweeklyreportreaddeail",
          "/projectloggingreportdeail",
          "/projectloggingreportreaddeail",
          "/projectworkreportdeail",
          "/auxiliaryestablishment",
          "/geologicalreport/auxiliaryestablishment",
          "/projectloggingresultsreportdeail",
          "/forgetpwd",
          "/cloud",
          "/keylaboratorydeail",
          "/keylaboratorystatisticsdeail"
        ];

        return arr.includes(this.$route.path.toLowerCase(), 0);
      },
      userName: function () {
        // `this` 指向 vm 实例
        return this.$store.getters.userName;
      }
    },
    watch: {
      "$store.getters.token": {
        handler: function (newVal, oldVal) {
          this.Islogin = (newVal !== 'undefined' && newVal != null && newVal !== "") ? true : false;
          //重新刷新菜单
          this.GetHeadData();
        },
      },
    },
    mounted() {
      // this.navWidth = document.getElementById("navigationItem").offsetWidth+ "px";
      // this.navHeight = document.getElementById("navigationItem").offsetHeight + "px";
      // this.use(VueCoreVideoPlayer)
      this.GetHeadData();
    },
    methods: {
      onclick() {
        if (
          this.$store.getters.rolesName == "个人角色"
          // || store.getters.userInfo.LoginName == "lradmin"
        ) {
          this.$router.push(`/PersonalCenter`);
        } else {
          this.$router.push(`/EnterpriseCenter`);
        }
      },
      GetHeadData() {
        let username = this.userName;
        GetData({
          username: username
        }).then((res) => {
          if (res.Code == 200) {
            this.headList = res.Data;
          } else {
            this.headList = [];
          }
        });
      },
      getUserManualALLList() {
        getUserManualALLList().then(res => {
          if (res.Code === 200) {
            this.tableUserManualData = res.Data;
          } else {
            this.tableUserManualData = [];
          }
        });
      },
      enterClick(index) {
        this.seen = true;
        this.current = index;
      },
      leave() {
        this.seen = false;
        this.current = null;
      },
      async logout() {
        let that = this;
        await this.$store.dispatch("user/logout", {
          Userid: that.$store.getters.userInfo.UserID
        });
        this.$router.push(`/login`);
      },
      submiturl() {
        let searchtext = this.seachvalue;
        let url = "";
        if (searchtext != "") {
          url = '' + process.env.VUE_APP_Zhiwang_URL + '/chome/Multi_local?kw=escape("' + searchtext + '")';
        } else {
          url = '' + process.env.VUE_APP_Zhiwang_URL + '/chome/Multi_local?kw=';
        }
        window.location.href = url;
      },
      showym() {
        this.dialogTableVisible = true;
        this.getUserManualALLList();
      },
      handleClick(index, row) {
        let a = document.createElement('a');
        let url = row.URL;
        a.href = row.URL;
        top.document.body.appendChild(a)
        a.click();
        top.document.body.removeChild(a);
      },
      zxshow(index, row) {
        
        var suffix =row.URL.substring(row.URL.lastIndexOf(".")+1);
        if(suffix=='pdf'||suffix=='doc'||suffix=='docx')
        {
        let Base64 = require('js-base64').Base64;
        let url = row.URL;
        let a = document.createElement('a')
        a.href = process.env.VUE_APP_Preview_URL + 'onlinePreview?url=' + encodeURIComponent(Base64.encode(url));
        a.setAttribute('target', '_blank');
        top.document.body.appendChild(a)
        a.click();
        top.document.body.removeChild(a);
        }
        else
        {
        let routeUrl = this.$router.resolve({ path: '/video', query: { URL: row.URL } });
        window.open (routeUrl.href, '_blank ')//关键在此
        }
       
      },
    },
  };

</script>
<style scoped>
  .qr-code-hover {
    display: none;
    text-align: center;
    position: absolute;
    width: 230px;
    padding: 20px 0;
    background: #fff;
    border-radius: 2px;
    right: 0;
    top: 21px;
  }

  .download-text-box:hover .qr-code-hover {
    display: block;
  }

</style>
<style>
  .hasHeaderBg {
    background: #3385ff;
    box-shadow: 2px 2px 5px #777;
  }

  .APPDownloadDialog .el-dialog__headerbtn {
    top: -15px;
    color: #fff;
    background: #555;
    border-radius: 50%;
    width: 200px;
    border: 2px solid #fff;
    right: -10px;
  }

  .APPDownloadDialog .el-dialog__headerbtn i {
    color: #fff !important;
  }

  .APPDownloadDialog .el-dialog__headerbtn:hover {
    background: #007bff;
  }

/deep/.top-dl .el-icon-arrow-down:before {
    color: #ffffff !important;
}

</style>



// WEBPACK FOOTER //
// src/layout/components/header/head.vue